<template>
  <Transition appear name="fade">
    <slot />
  </Transition>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  :deep(.modal-container) {
    transform: translateY(20px);
  }
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
  transition: $basic_transition;
}
</style>
